import React from 'react';
import styles from './Benefit.module.scss';
import BackgroundImage from "./components/background-image/BackgroundImage";
import {PanelInfo} from "./components/panel-info/PanelInfo";
import {HomeBenefits as features} from "application/globals/home-data";

export const Benefit = (props) => {
  return (
    <>
      <div className="pt-8" id="benefit-section" />
      <div className={styles.container}>
        <BackgroundImage className={styles.backgroundImage}/>

        <div className={styles.infoContainer}>
          <h1 className="text-center">
            Beneficios de la auto inscripción
          </h1>

          <div className={styles.infoBody}>
            {
              features.map(feature => <PanelInfo {...feature} key={feature.title}/>)
            }
          </div>
        </div>
      </div>
    </>
  );
};

Benefit.propTypes = {}

Benefit.defaultProps = {}

export default React.memo(Benefit);
